import { render } from "react-dom";
import "@alifd/next/dist/next.css";

import App from "./App";

const rootElement = document.getElementById("root");
render(<App />, rootElement);
